<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" lg="12" md="12">
        <v-card class="mt-0 px-5">
          <v-form id="form" v-if="invoice">
            <v-row>
              <v-col cols="12" md="4">
                <v-row>
                  <!-- <v-col cols="12" md="4">
                    <span v-if="invoice.vendorEntity.gstin">
                      GSTIN : {{ invoice.vendorEntity.gstin }}
                      <br />
                    </span>
                    <span
                      v-if="
                        !invoice.vendorEntity.gstin &&
                        invoice.vendorConfig &&
                        invoice.vendorConfig.gstin
                      "
                    >
                      GSTIN :
                      <strong>{{ invoice.vendorConfig.gstin }}</strong>
                      <br />
                    </span>
                  </v-col>
                  <v-col cols="12" md="4">
                    <span v-if="invoice.vendorName">
                      Name :
                      <strong>{{ invoice.vendorName }}</strong>
                      <br />
                    </span>
                  </v-col>
                  <v-col cols="12" md="4">
                    <span v-if="invoice.vendorEntity.address.addressLine">
                      Address: {{ invoice.vendorEntity.address.addressLine }}
                      <br />
                    </span>
                  </v-col>
                  <v-col cols="12" md="4">
                    <span
                      v-if="
                        !invoice.vendorEntity.address.addressLine &&
                        invoice.vendorAddress
                      "
                    >
                      Address: {{ invoice.vendorAddress }}
                      <br />
                    </span>
                  </v-col>
                  <v-col cols="12" md="4">
                    <span v-if="invoice.vendorPhone">
                      Mob : {{ invoice.vendorEntity.invoicePhone }}
                      <br />
                    </span>
                  </v-col>
                  <v-col cols="12" md="4">
                    <span v-if="invoice.vendorEmail">
                      Email : {{ invoice.vendorEntity.invoiceEmail }}
                      <br />
                    </span>
                  </v-col> -->

                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col cols="12" md="6">
                        <z-date-picker
                          v-model="invoice.invoiceDate"
                          :label="$i18n.t('Invoice Date')"
                        />
                      </v-col>
                      <v-col cols="12" md="6">
                        <z-entity-select
                          v-model="invoice.vendorEntity._id"
                          :corp="invoice.vendor_id"
                          :label="$i18n.t('Vendor Entity')"
                          autoSelect
                          @change="
                            fetchAppliedTaxSlab();
                            getInvoiceNo();
                          "
                          @fullEntity="fullEntity"
                          :item="invoice.vendorEntity"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                  <!-- <v-col
                    cols="12"
                    md="12"
                    v-if="invoice.vendorConfig.serviceCode"
                    >Service Account Code :
                    {{ invoice.vendorConfig.serviceCode }}</v-col
                  >
                  <v-col cols="12" md="12" v-if="invoice.vendorConfig.pan"
                    >PAN : {{ invoice.vendorConfig.pan }}</v-col
                  >
                  <v-col cols="12" md="12" v-if="invoice.vendorConfig.cin"
                    >CIN : {{ invoice.vendorConfig.cin }}</v-col
                  >
                  <v-col cols="12" md="12" v-if="invoice.vendorConfig.epfo"
                    >EPFO : {{ invoice.vendorConfig.epfo }}</v-col
                  >
                  <v-col cols="12" md="12" v-if="invoice.vendorConfig.esic"
                    >ESIC : {{ invoice.vendorConfig.esic }}</v-col
                  >
                  <v-col cols="12" md="12" v-if="invoice.vendorConfig.stateCode"
                    >State Code : {{ invoice.vendorConfig.stateCode }}</v-col
                  >
                  <v-col cols="12" md="12" v-if="invoice.vendorConfig.lutNo"
                    >LUT No : {{ invoice.vendorConfig.lutNo }}</v-col
                  > -->

                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col cols="12" md="6">
                        <z-client-select
                          v-model="invoice.client_id"
                          :label="$i18n.t('Client')"
                          withSelf
                        />
                      </v-col>
                      <v-col cols="12" md="6">
                        <z-currency-select
                          v-model="invoice.fare.currency"
                          :label="$i18n.t('Currency')"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-spacer />
              <v-col cols="12" md="4">
                <v-row>
                  <v-col cols="12" md="12">
                    <v-checkbox
                      :label="$i18n.t('For Individual')"
                      v-model="invoice.forIndividual"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row v-if="invoice.forIndividual">
                  <v-col cols="12" md="4">
                    <v-text-field
                      :label="$i18n.t('Pax Name')"
                      v-model="invoice.passenger.name"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      :label="$i18n.t('Pax Email')"
                      v-model="invoice.passenger.email"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      :label="$i18n.t('Pax Phone')"
                      v-model="invoice.passenger.phone"
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <z-country-select
                      v-model="invoice.passenger.address.country"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <z-state-select
                      v-model="invoice.passenger.address.state"
                      :coutry="invoice.passenger.address.country"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      :label="$i18n.t('Address')"
                      v-model="invoice.passenger.address.addressLine"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      :label="$i18n.t('PAN')"
                      v-model="invoice.passenger.panNumber"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      :label="$i18n.t('GSTIN')"
                      v-model="invoice.passenger.gstin"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-text-field
                      :label="$i18n.t('Invoice Title')"
                      v-model="invoice.chargesLabel"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <z-date-picker
                      v-model="invoice.fromDate"
                      :label="$i18n.t('Invoice Duties From')"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <z-date-picker
                      v-model="invoice.toDate"
                      :label="$i18n.t('Invoice Duties Till')"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row v-if="invoice.client_id">
              <v-col cols="12" md="12">
                <v-row>
                  <v-col cols="12" md="4">
                    <z-entity-select
                      :corp="invoice.client_id"
                      v-model="invoice.clientEntity._id"
                      @fullEntity="fullEntity"
                      :item="invoice.clientEntity"
                      :label="$i18n.t('Bill To')"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <z-entity-select
                      :corp="invoice.client_id"
                      v-model="invoice.shippedToEntity._id"
                      @input="
                        fetchAppliedTaxSlab();
                        getInvoiceNo();
                      "
                      @fullEntity="fullEntity"
                      :item="invoice.shippedToEntity"
                      :label="$i18n.t('Ship To')"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-row>
                      <v-col cols="12" md="8">
                        <v-text-field
                          v-model="invoice.invoiceNo"
                          @blur="invoiceNoAvailable"
                          :label="$i18n.t('Invoice No')"
                        />
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-btn @click="getInvoiceNo" text fab>
                          <v-icon>mdi-reload</v-icon>
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        md="2"
                        v-if="error_invoice_no_not_available"
                      >
                        <span style="color: red">
                          <b>Not valilable</b>
                        </span>
                      </v-col>
                    </v-row>
                  </v-col>
                  <!-- <v-col
                    cols="12"
                    md="2"
                    v-if="invoice.vendorEntity._id && appliedTaxSlab"
                  >
                    <label>Invoice Tax Will be Applied</label>
                    <span style="color: red"
                      >{{ appliedTaxSlab.name }}
                      {{
                        appliedTaxSlab.desc ? "-" + appliedTaxSlab.desc : ""
                      }}</span
                    >
                  </v-col> -->
                </v-row>
              </v-col>
            </v-row>

            <v-row v-if="invoice.client_id && invoice.shippedToEntity._id">
              <v-col cols="12" md="12">
                <v-card>
                  <v-list-item-content calss="px-3">
                    <v-row>
                      <v-col cols="12" md="4" class="px-5">
                        <h3>{{ $i18n.t("Trip(s) / Cargo(s)") }}</h3>
                      </v-col>
                      <v-spacer />
                    </v-row>
                  </v-list-item-content>
                  <v-simple-table>
                    <template v-slot:default>
                      <tbody
                        v-for="(trip, index) in invoice.tripInvoiceTOS"
                        :key="'item' + index"
                        class="my-table-body"
                      >
                        <tr>
                          <td
                            style="
                              width: 5%;
                              text-align: center;
                              border-bottom: 0px;
                            "
                          >
                            {{ index + 1 }}.
                          </td>
                          <td colspan="3" class="p-0" style="width: 95%">
                            <table style="width: 100%">
                              <tbody class="no-border-table detail-table">
                                <tr>
                                  <td>
                                    <z-vehicle-type-select
                                      v-model="trip.vehicle.vehicleType"
                                      :label="$i18n.t('Truck Type')"
                                    />
                                  </td>
                                  <td>
                                    <v-text-field
                                      v-model="trip.vehicle.regNo"
                                      :label="$i18n.t('Reg No')"
                                    />
                                  </td>
                                  <td>
                                    <z-date-picker
                                      v-model="trip.startTime"
                                      :label="$i18n.t('From Date')"
                                      timestamp
                                    />
                                  </td>
                                  <td>
                                    <z-date-picker
                                      v-model="trip.endTime"
                                      :label="$i18n.t('To Date')"
                                      timestamp
                                    />
                                  </td>
                                  <td style="padding: 0 10px">
                                    <v-btn
                                      color="error"
                                      x-small
                                      fab
                                      v-if="invoice.tripInvoiceTOS.length > 1"
                                      @click="
                                        removeItem(
                                          invoice.tripInvoiceTOS,
                                          index
                                        )
                                      "
                                      class="float-right me-10"
                                    >
                                      <v-icon>mdi-minus</v-icon>
                                    </v-btn>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <v-text-field
                                      v-model="trip.source.addressLine"
                                      :label="$i18n.t('PickUp')"
                                    />
                                  </td>
                                  <td>
                                    <v-text-field
                                      v-model="trip.destination.addressLine"
                                      :label="$i18n.t('DropOff')"
                                    />
                                  </td>
                                  <td>
                                    <v-text-field
                                      v-model="trip.cargos[0].lr.number"
                                      :label="$i18n.t('LR Number')"
                                    />
                                  </td>
                                  <td>
                                    <z-date-picker
                                      v-model="trip.cargos[0].lr.date"
                                      :label="$i18n.t('LR Date')"
                                      timestamp
                                    />
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                        <tr
                          v-for="(charge, index1) in trip.fare.charges"
                          :key="'trip' + index1"
                        >
                          <td style="padding: 0; width: 95%" colspan="4">
                            <v-simple-table style="background: transparent">
                              <tbody
                                class="charges-table-body"
                                style="width: 100%"
                              >
                                <tr>
                                  <td>
                                    <v-simple-table v-if="charge" dense>
                                      <thead>
                                        <tr
                                          style="
                                            background-color: rgb(235 244 246);
                                          "
                                        >
                                          <th>{{ $i18n.t("Name") }}</th>
                                          <!-- <th>{{ $i18n.t("Description") }}</th> -->
                                          <th width="90px">
                                            {{ $i18n.t("Unit(s)") }}
                                          </th>
                                          <th>{{ $i18n.t("Rate") }}</th>
                                          <th width="150px">
                                            {{ $i18n.t("Amount") }}
                                          </th>
                                          <th>
                                            <v-btn
                                              v-if="
                                                charge &&
                                                (!charge.items ||
                                                  charge.items.length == 0)
                                              "
                                              @click="
                                                charge.items = newItem(
                                                  charge.items
                                                )
                                              "
                                              text
                                              x-small
                                              fab
                                              color="blue"
                                            >
                                              <v-icon>mdi-plus</v-icon>
                                            </v-btn>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody
                                        v-if="
                                          charge.items && charge.items.length
                                        "
                                      >
                                        <tr
                                          v-for="(item, i) in charge.items"
                                          :key="i"
                                        >
                                          <td>
                                            <z-name-master-select
                                              v-model="item.name"
                                              :dense="true"
                                              :type="8"
                                              label
                                              :hideAddNew="true"
                                              :addNewLabel="'Add Fare Item'"
                                            />
                                          </td>
                                          <td>
                                            <v-text-field
                                              v-model="item.units"
                                              type="number"
                                              class="ma-0 pa-0"
                                              @change="calculateFare(trip)"
                                            />
                                          </td>
                                          <td>
                                            <v-text-field
                                              v-model="item.unitCost"
                                              type="number"
                                              class="ma-0 pa-0"
                                              @change="calculateFare(trip)"
                                            />
                                          </td>
                                          <td>
                                            <v-text-field
                                              v-model="item.amount"
                                              type="number"
                                              class="ma-0 pa-0"
                                              disabled
                                            />
                                          </td>
                                          <td>
                                            <v-row>
                                              <v-col cols="12" md="12">
                                                <v-btn
                                                  class="float-left"
                                                  color="error"
                                                  x-small
                                                  fab
                                                  text
                                                  dark
                                                  v-if="charge"
                                                  @click="
                                                    remove(
                                                      charge.items,
                                                      i,
                                                      true
                                                    )
                                                  "
                                                >
                                                  <v-icon
                                                    >mdi-minus-circle</v-icon
                                                  >
                                                </v-btn>
                                                <v-btn
                                                  class="float-left"
                                                  v-if="
                                                    charge &&
                                                    charge.items.length == i + 1
                                                  "
                                                  @click="
                                                    charge.items = newItem(
                                                      charge.items
                                                    )
                                                  "
                                                  text
                                                  x-small
                                                  fab
                                                  color="blue"
                                                >
                                                  <v-icon>mdi-plus</v-icon>
                                                </v-btn>
                                              </v-col>
                                            </v-row>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </v-simple-table>
                                  </td>
                                  <td
                                    style="
                                      padding-left: 0px;
                                      padding-right: 0px;
                                    "
                                  >
                                    <v-simple-table v-if="charge" dense>
                                      <thead>
                                        <tr
                                          style="
                                            background-color: rgb(235 244 246);
                                          "
                                        >
                                          <th width="40%">
                                            {{ $i18n.t("Name") }}
                                          </th>
                                          <th width="40%">
                                            {{ $i18n.t("Amount") }}
                                          </th>
                                          <th>
                                            <v-btn
                                              v-if="
                                                charge &&
                                                (!charge.discounts ||
                                                  charge.discounts.length == 0)
                                              "
                                              @click="
                                                charge.discounts = newDiscountItem(
                                                  charge.discounts
                                                )
                                              "
                                              text
                                              x-small
                                              fab
                                              color="blue"
                                            >
                                              <v-icon>mdi-plus</v-icon>
                                            </v-btn>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody
                                        v-if="
                                          charge.discounts &&
                                          charge.discounts.length
                                        "
                                      >
                                        <tr
                                          v-for="(disc, i) in charge.discounts"
                                          :key="i"
                                        >
                                          <td>
                                            <z-name-master-auto-fill
                                              v-model="disc.name"
                                              :dense="true"
                                              :type="9"
                                              label
                                              :addNewLabel="'Add Discount Item'"
                                            />
                                          </td>
                                          <td>
                                            <v-text-field
                                              v-model="disc.amount"
                                              class="ma-0 pa-0"
                                              type="number"
                                              @change="calculateFare(trip)"
                                            />
                                          </td>
                                          <td>
                                            <v-row>
                                              <v-col cols="12" md="12">
                                                <v-btn
                                                  class="float-left"
                                                  color="error"
                                                  x-small
                                                  fab
                                                  text
                                                  dark
                                                  v-if="charge"
                                                  @click="
                                                    remove(
                                                      charge.discounts,
                                                      i,
                                                      true
                                                    )
                                                  "
                                                >
                                                  <v-icon
                                                    >mdi-minus-circle</v-icon
                                                  >
                                                </v-btn>
                                                <v-btn
                                                  class="float-left"
                                                  v-if="
                                                    charge &&
                                                    charge.discounts.length ==
                                                      i + 1
                                                  "
                                                  @click="
                                                    charge.discounts = newDiscountItem(
                                                      charge.discounts
                                                    )
                                                  "
                                                  text
                                                  x-small
                                                  fab
                                                  color="blue"
                                                >
                                                  <v-icon>mdi-plus</v-icon>
                                                </v-btn>
                                              </v-col>
                                            </v-row>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </v-simple-table>
                                  </td>
                                  <td width="150px">
                                    <v-simple-table v-if="charge" dense>
                                      <thead>
                                        <tr>
                                          <th>{{ $i18n.t("Tax") }}</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <z-tax-select
                                          class1="ma-0 pa-0"
                                          v-model="charge.taxItem.tax_id"
                                          :item="charge.taxItem"
                                          :corp="trip.vendor_id"
                                          @fullTax="fullTax"
                                          @input="calculateFare(trip)"
                                          hideLabel
                                        />
                                      </tbody>
                                    </v-simple-table>
                                  </td>
                                  <td>
                                    <h3>
                                      <v-icon>mdi-sigma</v-icon>
                                      {{ trip.fare.total }}
                                    </h3>
                                    <v-btn
                                      class="float-left"
                                      color="error"
                                      x-small
                                      fab
                                      text
                                      dark
                                      v-if="
                                        trip.fare &&
                                        trip.fare.charges.length > 1
                                      "
                                      @click="
                                        remove(trip.fare.charges, index1, true)
                                      "
                                    >
                                      <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                    <v-btn
                                      v-if="
                                        trip.fare &&
                                        trip.fare.charges.length == index1 + 1
                                      "
                                      @click="
                                        trip.fare.charges = newChargeItem(
                                          trip.fare.charges
                                        )
                                      "
                                      x-small
                                      color="secondary"
                                      fab
                                      class="float-right me-10"
                                    >
                                      <v-icon>mdi-plus</v-icon>
                                    </v-btn>
                                  </td>
                                </tr>
                              </tbody>
                            </v-simple-table>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <v-list-item-content calss="px-3">
                    <v-row>
                      <v-spacer />
                      <v-col clos="12" md="6">
                        <v-btn
                          @click="
                            invoice.tripInvoiceTOS = newTripInvoiceTO(
                              invoice.tripInvoiceTOS
                            )
                          "
                          x-small
                          style="width: 60px; float: right"
                          color="primary"
                        >
                          <v-icon>mdi-plus</v-icon>
                          <h3>{{ $i18n.t("Add") }}</h3>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-spacer/>
                <v-col cols="12" md="4">
                  <EInvoice :invoice_id="invoice._id" :invoiceStatus="invoice.status"></EInvoice>
                </v-col>
              </v-row>

            <v-row v-if="invoice.client_id && invoice.shippedToEntity._id">
              <v-spacer />
                <v-col cols="12" md="4">
                  <div class="d-flex my-3" style="flex-direction: column;">
                      <v-row>
                        <v-col>
                          <h3>{{ $i18n.t("Sub Total") }}</h3>
                        </v-col>
                        <v-col class="text-right">
                          {{ invoice.fare ? invoice.fare.subTotal : 0 }}
                        </v-col>
                      </v-row>
                  </div>
                  <div class="d-flex my-3" style="flex-direction: column;">
                      <v-row>
                        <v-col>
                          <h3>{{ $i18n.t("Discount") }}</h3>
                        </v-col>
                        <v-col class="text-right">
                          {{ invoice.fare ? invoice.fare.totalDiscounts : 0 }}
                        </v-col>
                      </v-row>
                  </div>
                  <div v-for="(tax, i) in invoice.fare.taxes"
                        :key="'tax' + i" class="d-flex my-3" style="flex-direction: column;">
                      <v-row>
                        <v-col>
                          <h3>{{ tax.name }}</h3>
                        </v-col>
                        <v-col class="text-right">
                          {{ tax.amount || 0 }}
                        </v-col>
                      </v-row>
                  </div>
                  <div class="d-flex my-3" style="flex-direction: column;">
                      <v-row>
                        <v-col>
                          <h3>{{ $i18n.t("Total") + " (" }}{{ invoice.fare.currency
                          }}{{ ")" }}</h3>
                        </v-col>
                        <v-col class="text-right">
                          {{ invoice.fare ? invoice.fare.total : 0 }}
                        </v-col>
                      </v-row>
                  </div>
                </v-col>
            </v-row>

            <v-row v-if="invoice.client_id && invoice.shippedToEntity._id">
              <!-- <v-col cols="12" class="text-right"> -->
                <z-confirm-button
                  color="red"
                  small
                  :message="$i18n.t('Do you want to cancel this invoice ?')"
                  v-if=" (invoice.status == 0 || invoice.status == 1) && !invoice.nonEditable"
                  class="bill-right-headers"
                  @click="cancelInvoice()"
                >
                  <v-icon>mdi-cancel</v-icon> {{ $i18n.t("Cancel") }} 
                </z-confirm-button>
                <v-spacer />
                <v-btn
                  text
                  fab
                  x-small
                  :title="$i18n.t('Print Invoice')"
                  small
                  v-if="invoice_id"
                  color="primary"
                  @click="invDownload()"
                >
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-btn
                  color="info"
                  class="mr-0"
                  @click="createInvoice()"
                  :loading="loading"
                >
                  <h3>{{ $i18n.t("Save") }}</h3>
                </v-btn>
              <!-- </v-col> -->
            </v-row>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <z-invoice-download
      :payload="payload"
      :showDialog="showInvoiceDoanload"
      @closeDialog="closeDialog"
      :isMail="isMail"
      :invoice="invForMail"
    ></z-invoice-download>
  </v-container>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import { CommonUtil } from "@/js/commonUtil";
import EInvoice from "./EInvoice.vue";


@Component({
  name:"ManualInvoice",
  components:{
    EInvoice
  }
})
export default class ManualInvoice extends Vue {
  corpConfig = {};
  invoice = null;
  client = {};
  vendor = {};
  invoiceEdit = false;
  extraFare = { charges: [] };
  entityList = [];
  entityListClient = [];
  invoiceEdit = true;
  invoice_id = null;
  invoice_ID = null;
  showInvoiceDoanload = false;
  invoicePolicyContent = "";
  error_invoice_no_not_available = false;
  appliedTaxSlab = {};
  payload = {};
  isMail = false;
  invForMail = null;

  download = {
    showDialog: false,
    template: "0",
    types: [],
    templateList: [],
    bookingTemplateList: [],
  };
  @Watch('invoice', { immediate: true, deep: true })
  consoleWatch() {
     console.log(this.invoice);
  }

  newTripInvoiceTO(itemList) {
    if (itemList == null) itemList = [];
    const item = JSON.parse(JSON.stringify(this.newTripInvoiceTOData));
    if (!item['fare']) {
      item['fare'] = {};
    }
    item['fare']['charges'] = [];
    this.newChargeItem(item.fare.charges);
    console.log(item);
    itemList.push(item);
    return itemList;
  }

  fullTax(taxDetail, item) {
    item.taxDetail = taxDetail;
  }

  fullEntity(entity, item) {
    item.details = entity;
  }

  async mounted() {
    if (this.$route.params.id) {
      this.invoice_id = this.$route.params.id;
    }
    await this.fetchInvoice();

    this.invoicePolicyContent = await doGet(
      "/api/static/content/render/INVOICE_POLICY"
    );
  }

  get loading() {
    return common.loading;
  }

  async fetchTaxList(client_id, vendor_id) {
    this.taxList = await doGet(
      "/api/corp/tax/client/" + client_id + "/vendor/" + vendor_id
    );
  }

  prepareInvoiceDetail(_invoice) {
    if (!_invoice) _invoice = {};
    if (!_invoice.invoiceNo) _invoice.invoiceNo = null;
    if (!_invoice.client_id) _invoice.client_id = null;
    if (!_invoice.vendor_id) _invoice.vendor_id = null;
    if (!_invoice.subTitle) _invoice.subTitle = null;
    if (!_invoice.subHeading) _invoice.subHeading = null;
    if (!_invoice.chargesLabel) _invoice.chargesLabel = null;
    if (!_invoice.fromDate) _invoice.fromDate = null;
    if (!_invoice.toDate) _invoice.toDate = null;
    if (!_invoice.invoiceDate) _invoice.invoiceDate = null;
    if (!_invoice.forIndividual) _invoice.forIndividual = null;

    if (!_invoice.vendorEntity) _invoice.vendorEntity = {};
    if (!_invoice.clientEntity) _invoice.clientEntity = {};
    if (!_invoice.shippedToEntity) _invoice.shippedToEntity = {};

    if (!_invoice.tripInvoiceTOS) _invoice.tripInvoiceTOS = [];
    for (let index = 0; index < _invoice.tripInvoiceTOS.length; index++) {
      if (!_invoice.tripInvoiceTOS[index].routeNo)
        _invoice.tripInvoiceTOS[index].routeNo = null;
      if (!_invoice.tripInvoiceTOS[index].vehicleType)
        _invoice.tripInvoiceTOS[index].vehicleType = null;

      if (!_invoice.tripInvoiceTOS[index].cargos) _invoice.tripInvoiceTOS[index].cargos = [];
      if (_invoice.tripInvoiceTOS[index].cargos.length < 1) {
        const c = {lr:{number:null, date:null}};
        _invoice.tripInvoiceTOS[index].cargos.push(c);
      }

      if (!_invoice.tripInvoiceTOS[index].source)
        _invoice.tripInvoiceTOS[index].source = {};
      if (!_invoice.tripInvoiceTOS[index].source.addressLine)
        _invoice.tripInvoiceTOS[index].source.addressLine = null;

      if (!_invoice.tripInvoiceTOS[index].destination)
        _invoice.tripInvoiceTOS[index].destination = {};
      if (!_invoice.tripInvoiceTOS[index].destination.addressLine)
        _invoice.tripInvoiceTOS[index].destination.addressLine = null;

      // if (!_invoice.tripInvoiceTOS[index].fareTariff)
      //   _invoice.tripInvoiceTOS[index].fareTariff = {};
      // if (!_invoice.tripInvoiceTOS[index].fareTariff.name)
      //   _invoice.tripInvoiceTOS[index].fareTariff.name = null;

      if (!_invoice.tripInvoiceTOS[index].vehicle)
        _invoice.tripInvoiceTOS[index].vehicle = {};
      if (!_invoice.tripInvoiceTOS[index].vehicle.regNo)
        _invoice.tripInvoiceTOS[index].vehicle.regNo = null;
      if (!_invoice.tripInvoiceTOS[index].costCenter)
        _invoice.tripInvoiceTOS[index].costCenter = null;

      if (!_invoice.tripInvoiceTOS[index].fare)
        _invoice.tripInvoiceTOS[index].fare = {};
      if (!_invoice.tripInvoiceTOS[index].fare.charges)
        _invoice.tripInvoiceTOS[index].fare.charges = [];

      for (
        let u = 0;
        u < _invoice.tripInvoiceTOS[index].fare.charges.length;
        u++
      ) {
        if (!_invoice.tripInvoiceTOS[index].fare.charges[u].items) {
          _invoice.tripInvoiceTOS[index].fare.charges[u].items = [];
        }
        if (!_invoice.tripInvoiceTOS[index].fare.charges[u].discounts) {
          _invoice.tripInvoiceTOS[index].fare.charges[u].discounts = [];
        }

        for (
          let _i = 0;
          _i < _invoice.tripInvoiceTOS[index].fare.charges[u].items.length;
          _i++
        ) {
          if (!_invoice.tripInvoiceTOS[index].fare.charges[u].items[_i].name)
            _invoice.tripInvoiceTOS[index].fare.charges[u].items[
              _i
            ].name = null;

          if (!_invoice.tripInvoiceTOS[index].fare.charges[u].items[_i].desc)
            _invoice.tripInvoiceTOS[index].fare.charges[u].items[
              _i
            ].desc = null;

          if (!_invoice.tripInvoiceTOS[index].fare.charges[u].items[_i].units)
            _invoice.tripInvoiceTOS[index].fare.charges[u].items[
              _i
            ].units = null;

          if (
            !_invoice.tripInvoiceTOS[index].fare.charges[u].items[_i].unitCost
          )
            _invoice.tripInvoiceTOS[index].fare.charges[u].items[
              _i
            ].unitCost = null;
        }

        for (
          let _i = 0;
          _i < _invoice.tripInvoiceTOS[index].fare.charges[u].discounts.length;
          _i++
        ) {
          if (
            !_invoice.tripInvoiceTOS[index].fare.charges[u].discounts[_i].name
          )
            _invoice.tripInvoiceTOS[index].fare.charges[u].discounts[
              _i
            ].name = null;

          if (
            !_invoice.tripInvoiceTOS[index].fare.charges[u].discounts[_i].desc
          )
            _invoice.tripInvoiceTOS[index].fare.charges[u].discounts[
              _i
            ].desc = null;

          if (
            !_invoice.tripInvoiceTOS[index].fare.charges[u].discounts[_i].units
          )
            _invoice.tripInvoiceTOS[index].fare.charges[u].discounts[
              _i
            ].units = null;

          if (
            !_invoice.tripInvoiceTOS[index].fare.charges[u].discounts[_i]
              .unitCost
          )
            _invoice.tripInvoiceTOS[index].fare.charges[u].discounts[
              _i
            ].unitCost = null;
        }

        // if (!_invoice.tripInvoiceTOS[index].fare.charges[u].amount)
        //   _invoice.tripInvoiceTOS[index].fare.charges[u].amount = null;

        if (!_invoice.tripInvoiceTOS[index].fare.charges[u].taxItem)
          _invoice.tripInvoiceTOS[index].fare.charges[u].taxItem = {};

        if (!_invoice.tripInvoiceTOS[index].fare.charges[u].taxItem.tax_id)
          _invoice.tripInvoiceTOS[index].fare.charges[u].taxItem.tax_id = null;
      }
    }
  }

  async fetchInvoice() {
    try {
      let url = "/api/invoice/get/empty";
      if (this.invoice_id) url = "/api/invoice/" + this.invoice_id + "/detail";

      const response = await doGet(url);

      this.prepareInvoiceDetail(response);
      this.invoice = response;
      this.newTripInvoiceTOData = JSON.parse(
        JSON.stringify(response.tripInvoiceTOS[0])
      );

      if (!this.invoice_id) {
        this.newChargeItem(this.invoice.tripInvoiceTOS[0].fare.charges);
        this.invoice.fare.currency = "INR";
      }
    } catch (e) {
      common.setError(e.error);
      common.setLoading(false);
    }
  }

  showSummary() {
    this.$router.push("/w/invoice/summary?_id=" + this.invoice_id);
  }

  // invoiceCharges() {
  //   console.log("fd");
  //   // $("#invoiceChargesDialog").modal("show");
  // }

  // async selectTax2(tax_id) {
  //   try {
  //     const response = await doPost(
  //       "/api/invoice/" + this.invoice_ID + "/amend/tax/" + tax_id
  //     );
  //     this.invoice = response;
  //     // $("#taxTypeDetail_dialog2").modal("hide");
  //     // alert("Tax type Changed.");
  //   } catch (e) {
  //     common.setError(e.error);
  //     common.setLoading(false);
  //   }
  // }

  // async editTaxType(invoice_id) {
  //   this.invoice_ID = invoice_id;
  //   try {
  //     this.taxDetail2 = await doGet("/api/taxslab/all");
  //     //   $("#taxTypeDetail_dialog2").modal("show");
  //   } catch (e) {
  //     common.setError(e.error);
  //     common.setLoading(false);
  //   }
  // }

  // flushClientEntities() {
  //   this.invoice.clientEntity = {};
  //   this.invoice.shippedToEntity = {};
  //   this.invoice.invoiceNo = null;
  // }

  // async saveVendorEntity(invoice_id) {
  //   if (this.vendorEntity_id) {
  //     common.setLoading(true);
  //     try {
  //       const response = await doGet(
  //         "/api/invoice/" +
  //           invoice_id +
  //           "/save/vendor/entity/" +
  //           this.vendorEntity_id
  //       );
  //       this.invoice = response;
  //       common.showMessage("Invoice No and Date Changed.");
  //       common.setLoading(false);
  //     } catch (e) {
  //       common.setLoading(false);
  //       common.setError(e);
  //     }
  //   }
  // }

  // async updateInvoiceNoDate(invoice_id) {
  //   if (this.invoice.invoiceNo && this.invoice.invoiceDate) {
  //     common.setLoading(true);
  //     try {
  //       const response = await doGet(
  //         "/api/invoice/" +
  //           invoice_id +
  //           "/update/invoice/num/" +
  //           this.invoice.invoiceNo +
  //           "/date/" +
  //           this.invoice.invoiceDate
  //       );
  //       this.invoice = response;
  //       common.showMessage("Invoice No and Date Changed.");
  //       common.setLoading(false);
  //     } catch (e) {
  //       common.setLoading(false);
  //       common.setError(e);
  //     }
  //   }
  // }

  // async saveClientEntity(invoice_id) {
  //   if (this.clientEntity_id) {
  //     common.setLoading(true);
  //     try {
  //       const response = await doPost(
  //         "/api/invoice/" +
  //           invoice_id +
  //           "/save/client/entity/" +
  //           this.clientEntity_id
  //       );
  //       this.invoice = response;
  //       common.setLoading(false);
  //     } catch (e) {
  //       common.setLoading(false);
  //       common.setError(e);
  //     }
  //   }
  // }

  // async saveShippedEntity(invoice_id) {
  //   if (this.shippedEntity_id) {
  //     common.setLoading(true);
  //     try {
  //       const response = await doPost(
  //         "/api/invoice/" +
  //           invoice_id +
  //           "/save/shippedTo/entity/" +
  //           this.shippedEntity_id
  //       );
  //       this.invoice = response;
  //       common.setLoading(false);
  //     } catch (e) {
  //       common.setLoading(false);
  //       common.setError(e);
  //     }
  //   }
  // }

  // async verify() {
  //   try {
  //     await doGet("/api/invoice/" + this.invoice._id + "/verify");
  //     window.location.reload();
  //   } catch (e) {
  //     common.setError(e);
  //   }
  // }

  calulateTotalFare() {
    if (!this.invoice.tripInvoiceTOS) return;
    const t = this.invoice.fare.subTotal;
    this.invoice.fare.total = 0;
    this.invoice.fare.subTotal = 0;
    this.invoice.fare.totalDiscounts = 0;
    this.invoice.fare.totalTaxes = 0;
    const taxes = [];
    for (let i = 0; i < this.invoice.tripInvoiceTOS.length; i++) {
      if (this.invoice.tripInvoiceTOS[i].fare) {
        if (this.invoice.tripInvoiceTOS[i].fare.total) {
          this.invoice.fare.total =
            this.invoice.fare.total +
            parseFloat(this.invoice.tripInvoiceTOS[i].fare.total);
        }
        if (this.invoice.tripInvoiceTOS[i].fare.totalDiscounts) {
          this.invoice.fare.totalDiscounts =
            this.invoice.fare.totalDiscounts +
            parseFloat(this.invoice.tripInvoiceTOS[i].fare.totalDiscounts);
        }
        if (this.invoice.tripInvoiceTOS[i].fare.totalTaxes) {
          this.invoice.fare.totalTaxes =
            this.invoice.fare.totalTaxes +
            parseFloat(this.invoice.tripInvoiceTOS[i].fare.totalTaxes);
        }
        if (this.invoice.tripInvoiceTOS[i].fare.subTotal) {
          this.invoice.fare.subTotal =
            this.invoice.fare.subTotal +
            parseFloat(this.invoice.tripInvoiceTOS[i].fare.subTotal);
        }

        if (this.invoice.tripInvoiceTOS[i].fare.taxes != null) {
          for (const j in this.invoice.tripInvoiceTOS[i].fare.taxes) {
            const tax = this.invoice.tripInvoiceTOS[i].fare.taxes[j];
            let newItem = null;
            for (const k in taxes) {
              const t = taxes[k];
              if (t.name == tax.name) {
                newItem = t;
                break;
              }
            }
            if (newItem == null) {
              newItem = {
                name: tax.name,
                desc: tax.desc,
                amount: 0,
              };
              newItem.amount = newItem.amount + tax.amount;
              taxes.push(newItem);
            } else {
              newItem.amount = newItem.amount + tax.amount;
            }
          }
        }
      }
      if (t != this.invoice.fare.subTotal) this.fetchAppliedTaxSlab();
    }
    this.invoice.fare.taxes = taxes;
  }

  async calulateFareAllTripInvoice() {
    for (const i in this.invoice.tripInvoiceTOS) {
      await this.calculateFare(this.invoice.tripInvoiceTOS[i]);
    }
  }

  calculateFare(tripInvoice) {
    CommonUtil.calculateFare(
      tripInvoice,
      this.invoice.vendorEntity,
      this.invoice.shippedToEntity
    );
    this.calulateTotalFare();
  }

  // newChargeItem(itemList) {
  //   const item = { taxItem: {}, units: 1 };
  //   if (itemList == null) itemList = [];
  //   itemList.push(item);
  //   return itemList;
  // }

  newDiscountItem(itemList) {
    if (itemList == null) itemList = [];
    itemList.push({ name: null, amount: null });
    return itemList;
  }

  newChargeItem(itemList) {
    const tax_id =
      itemList &&
      itemList.length > 0 &&
      itemList[0].taxItem &&
      itemList[0].taxItem.tax_id
        ? itemList[0].taxItem.tax_id
        : null;

    if (itemList == null) itemList = [];

    const item = {
      taxItem: { tax_id: tax_id },
      // units: 1,
      // discountItem: {},
      discounts: [],
      items: [
        {
          name: null,
          desc: null,
          units: 1,
          unitCost: null,
          amount: null,
        },
      ],
    };

    itemList.push(item);
    return itemList;
  }

  newItem(itemList) {
    if (!itemList) itemList = [];
    itemList.push({
      name: null,
      desc: null,
      units: 1,
      unitCost: null,
      amount: null,
    });
    return itemList;
  }

  removeItem(itemList, item, tp) {
    this.remove(itemList, item);
    if (tp) {
      this.calculateFare(tp);
    }
  }

  remove(list, _index, calcFare) {
    list.splice(_index, 1);
    if (calcFare) this.calculateFare();
  }

  // async saveExtraFare() {
  //   try {
  //     await doPost(
  //       "/api/invoice/" + this.invoice._id + "/update/fare",
  //       this.extraFare
  //     );
  //     window.location.reload();
  //   } catch (e) {
  //     common.setError(e);
  //   }
  // }

  // validateCharges(charges) {
  //   if (!charges || charges.length == 0) return true;
  //   for (let i = 0; i < charges.length; i++) {
  //     if (!charges[i].name || charges[i].name.trim() == "") {
  //       common.setError("All charges name is mandatory.");
  //       return false;
  //     }
  //     if (!charges[i].amount || charges[i].amount == "") {
  //       common.setError("All charges name is mandatory.");
  //       return false;
  //     }
  //   }
  //   return true;
  // }

  // async saveCharges(InvoiceId) {
  //   if (!this.validateCharges(this.invoice.charges)) return;
  //   // this.invoice.invoiceDate="";
  //   try {
  //     await doPost("/api/invoice/charges/" + InvoiceId + "/add", this.invoice);
  //     common.showMessage("Charges added successfully.");
  //     window.location.reload();
  //   } catch (e) {
  //     common.setError(e);
  //   }
  // }

  dateTimeToTimestamp(dt, time) {
    const a = this.$moment(dt + (time ? time : "T00:00:00.000Z")).format("X");
    return parseInt(a) + new Date().getTimezoneOffset() * 60;
  }

  async createInvoice() {
    if (
      !this.invoice.tripInvoiceTOS ||
      this.invoice.tripInvoiceTOS.length < 1
    ) {
      common.setError("Please provide at least one trip fare detail.");
      return;
    }
    if (this.invoice.forIndividual) {
      if (!this.invoice.passenger || !this.invoice.passenger.name) {
        common.setError("Individual name and email is mandatory.");
        return;
      }
    } else {
      this.invoice.forIndividual = false;
    }
    if (!this.invoice.chargesLabel || this.invoice.chargesLabel.length < 10) {
      // console.log(this.invoice.chargesLabel);
      common.setError("Please provide charges label of atleast 10 characters.");
      return;
    }
    if (!this.invoice.fromDate || !this.invoice.toDate) {
      common.setError("Please select Duties from-to date.");
      return;
    }
    const url = "/api/invoice/save/empty";
    for (let i = 0; i < this.invoice.tripInvoiceTOS.length; i++) {
      if (
        this.invoice.tripInvoiceTOS[i].fare.charges &&
        this.invoice.tripInvoiceTOS[i].fare.charges.length > 0
      ) {
        for (
          let j = 0;
          j < this.invoice.tripInvoiceTOS[i].fare.charges.length;
          j++
        ) {
          const charge = this.invoice.tripInvoiceTOS[i].fare.charges[j];
          if (charge && charge.items) {
            for (let _i = 0; _i < charge.items.length; _i++) {
              if (!charge.items[_i].name) {
                common.setError("All charges name is mandatory.");
                return;
              }
              if (!charge.items[_i].amount) {
                common.setError("All charges amount is mandatory.");
                return;
              }
            }
          }

          if (charge && charge.discounts) {
            for (let _i = 0; _i < charge.discounts.length; _i++) {
              if (!charge.discounts[_i].name) {
                common.setError("All Discount name is mandatory.");
                return;
              }
              if (!charge.discounts[_i].amount) {
                common.setError("All Discount amount is mandatory.");
                return;
              }
            }
          }
        }
      }
      this.invoice.tripInvoiceTOS[i].fare.currency = this.invoice.fare.currency;
      // this.invoice.tripInvoiceTOS[i].startTime = this.dateTimeToTimestamp(
      //   this.invoice.tripInvoiceTOS[i].startDate,
      //   "00.00"
      // );
      // this.invoice.tripInvoiceTOS[i].endTime = this.dateTimeToTimestamp(
      //   this.invoice.tripInvoiceTOS[i].endDate,
      //   "23.59"
      // );
    }

    try {
      this.loading = true;
      common.setLoading(true);
      const response = await doPost(url, this.invoice);
      if (!this.invoice_id) {
        this.$router.push("/sales/invoice/manual/" + response._id);
      }
      this.invoice_id = response._id;
      await this.fetchInvoice();
      this.loading = null;
      common.setLoading(false);
    } catch (e) {
      this.loading = null;
      common.setLoading(false);
      common.setError(e);
    }
  }

  // async deleteCharge(InvoiceId, index) {
  //   try {
  //     await doGet("/api/invoice/charges/" + InvoiceId + "/delete/" + index);
  //     common.showMessage("Charges deleted successfully.");
  //     window.location.reload();
  //   } catch (e) {
  //     common.setError(e);
  //   }
  // }

  // addEditComment() {
  //   if (!this.commentTextId) {
  //     common.setError("Please provide some text.");
  //     return;
  //   }
  //   // $("#commentTextLabelId").text("Comment");

  //   const cmt = {};
  //   // cmt.msg = $("#commentTextId").val();
  //   // cmt.priority = $("#commentPriority").val();
  //   // cmt.commentsFor = $("#commentFor").val();
  //   cmt.by = "Self";
  //   cmt.commentBy = "Self";
  //   cmt.at = parseInt(new Date().getTime() / 1000);

  //   if (this.commentCallBack != undefined) {
  //     this.commentCallBack(this.selectedInvoice, this.selectedStatus, cmt);
  //     this.selectedInvoice = null;
  //     this.selectedStatus = null;
  //   } else {
  //     if (!this.invoice.comments) this.invoice.comments = [];
  //     this.invoice.comments.push(cmt);
  //   }

  //   // $("#adminCommentDialog").modal("hide");
  // }

  async fetchAppliedTaxSlab() {
    let url = "/api/invoice/create/get/tax/slab?";
    if (this.invoice.vendorEntity._id && this.invoice.shippedToEntity._id) {
      // this.calulateFareAllTripInvoice();
      url =
        url +
        "&vendor_id=" +
        this.invoice.vendor_id +
        "&clientEntity_id=" +
        this.invoice.shippedToEntity._id +
        "&vendorEntity_id=" +
        this.invoice.vendorEntity._id +
        "&client_id=" +
        this.invoice.client_id +
        "&forIndividual=" +
        this.invoice.forIndividual +
        "&amount=" +
        (this.invoice.fare ? this.invoice.fare.subTotal : null);
      try {
        this.appliedTaxSlab = await doGet(url);
      } catch (e) {
        console.log(e);
      }
    }
  }

  async getInvoiceNo() {
    if (
      !this.invoice._id &&
      this.invoice.vendor_id &&
      this.invoice.client_id &&
      this.invoice.vendorEntity &&
      this.invoice.vendorEntity._id &&
      this.invoice.shippedToEntity &&
      this.invoice.shippedToEntity._id
    ) {
      this.availableInvoiceNo = null;
      this.invoice.invoiceNo = null;
      let url = "/api/invoice/create/get/invoice/sequence?";
      url =
        url +
        "&vendor_id=" +
        this.invoice.vendor_id +
        "&clientEntity_id=" +
        this.invoice.shippedToEntity._id +
        "&vendorEntity_id=" +
        this.invoice.vendorEntity._id +
        "&client_id=" +
        this.invoice.client_id +
        "&date=" +
        this.invoice.invoiceDate +
        "&forIndividual=" +
        this.invoice.forIndividual;
      try {
        const response = await doGet(url);
        this.invoice.invoiceNo = response;
        this.availableInvoiceNo = response;
        this.error_invoice_no_not_available = false;
      } catch (e) {
        common.setError(e);
      }
    }
  }

  async invoiceNoAvailable() {
    let url = "/api/invoice/create/get/invoice/sequence/available?";
    this.error_invoice_no_not_available = false;
    if (
      this.invoice.vendorEntity &&
      this.invoice.vendorEntity._id &&
      (this.invoice.forIndividual ||
        (this.invoice.shippedToEntity && this.invoice.shippedToEntity._id)) &&
      this.invoice.invoiceNo
    ) {
      url =
        url +
        "&vendor_id=" +
        this.invoice.vendor_id +
        "&clientEntity_id=" +
        this.invoice.shippedToEntity._id +
        "&vendorEntity_id=" +
        this.invoice.vendorEntity._id +
        "&client_id=" +
        this.invoice.client_id +
        "&invoiceNo=" +
        this.invoice.invoiceNo +
        "&date=" +
        this.invoice.invoiceDate +
        "&forIndividual=" +
        this.invoice.forIndividual;
      try {
        await doGet(url);
      } catch (e) {
        this.error_invoice_no_not_available = true;
      }
    }
  }

  invDownload() {
    const _invoice = this.invoice;
    let ids = "";
    const clients = [];
    let vendor_id, client_id, vendorEntity_id, clientEntity_id;
    let v_consider = true;
    let c_consider = true;
    let vEntity_consider = true;
    let cEntity_consider = true;
    if (_invoice) {
      ids += _invoice._id;
      clients.push(_invoice.client_id);
      vendor_id = _invoice.vendor_id;
      client_id = _invoice.client_id;
      vendorEntity_id = _invoice.vendorEntity._id;
      clientEntity_id = _invoice.clientEntity._id;
    } else {
      this.grid.rows.forEach(function (t) {
        if (t.selected) {
          ids += t._id + ",";
          clients.push(t.client_id);
          if (v_consider) {
            if (vendor_id == null) {
              vendor_id = t.vendor_id;
            } else if (vendor_id != t.vendor_id) {
              v_consider = false;
            }
          }
          if (c_consider) {
            if (client_id == null) {
              client_id = t.client_id;
            } else if (client_id != t.client_id) {
              c_consider = false;
            }
          }
          if (vEntity_consider) {
            if (vendorEntity_id == null) {
              vendorEntity_id = t.vendorEntity._id;
            } else if (vendorEntity_id != t.vendorEntity._id) {
              vEntity_consider = false;
            }
          }
          if (cEntity_consider) {
            if (clientEntity_id == null) {
              clientEntity_id = t.clientEntity._id;
            } else if (clientEntity_id != t.clientEntity._id) {
              cEntity_consider = false;
            }
          }
        }
      });
    }

    if (!ids) {
      common.setError("Please select invoice(s) to download PDF/Excel");
      return false;
    }

    const payload = { invoice_ids: ids, client_ids: clients };
    if (v_consider) {
      payload.vendor_id = vendor_id;
    }
    if (c_consider) {
      payload.client_id = client_id;
    }
    if (vEntity_consider) {
      payload.vendorEntity_id = vendorEntity_id;
    }
    if (cEntity_consider) {
      payload.clientEntity_id = clientEntity_id;
    }
    this.payload = payload;
    this.showInvoiceDoanload = true;
  }

  async cancelInvoice() {
    this.loading = true;
    try {
      await doGet(`/api/invoice/${this.invoice._id}/cancel`);
      common.showMessage("Invoice cancelled.");
      this.fetchInvoice();
      this.loading = false;
    } catch (e) {
      this.loading = false;
      common.setError(e.message);
    }
  }

  closeDialog() {
    this.showInvoiceDoanload = false;
    this.payload = {};
    this.invForMail = null;
    this.isMail = false;
  }

  invEmail(_invoice) {
    this.invForMail = _invoice;
    this.isMail = true;
    this.showInvoiceDoanload = true;
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
.my-table-body td {
  border: 0px solid #f1f1f1;
}

.v-input input[type="number"] {
  text-align: right;
}

.my-table-body tr td,
.charges-table-body tr td {
  padding: 7px 2px 0px 2px !important;
  background: transparent;
}

.no-border-table td {
  border: none;
}

.my-table-body:nth-child(odd) {
  background-color: #f4f6f6;
}
.my-table-body:nth-child(even) {
  background-color: #ffffff;
}

.detail-table,
.detail-table tr,
.detail-table tr td,
.my-table-body tr,
.my-table-body tr td {
  background: transparent !important;
}
</style>
